var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnitedKingdomFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 20,
    viewBox: "0 0 31 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#41479B",
    d: "M30.465 20H.535A.53.53 0 0 1 0 19.474V.526C0 .236.24 0 .535 0h29.93A.53.53 0 0 1 31 .526v18.948a.53.53 0 0 1-.535.526z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M31 .526A.53.53 0 0 0 30.465 0h-2.39l-9.903 6.388V0h-5.345v6.388L2.926 0H.535A.53.53 0 0 0 0 .526v1.362l8.495 5.48H0v5.264h8.495L0 18.112v1.362c0 .29.24.526.535.526h2.39l9.903-6.388V20h5.344v-6.388L28.074 20h2.391a.53.53 0 0 0 .535-.526v-1.362l-8.495-5.48H31V7.368h-8.495L31 1.888V.526z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FF4B55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.94 8.424H17.07V.016h-3.2v8.408H0v3.152h13.87v8.408h3.2v-8.408h13.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.814 12.627L.015 19.532c.038.254.25.452.518.452h.735l11.505-7.357h-1.96zM20.932 12.627h-1.96l11.489 7.346a.523.523 0 0 0 .479-.515v-.432l-10.008-6.399zM0 1.122l9.776 6.25h1.96L.31.069A.523.523 0 0 0 0 .542v.58zM20.097 7.373L30.92.452a.524.524 0 0 0-.515-.436h-.764L18.137 7.373h1.96z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedKingdomFooter);
export default __webpack_public_path__ + "static/media/united-kingdom-footer.ee6dda93.svg";
export { ForwardRef as ReactComponent };